import React from "react";
import useScript from "Helpers/Hooks";
import FormContainer from "Containers/FormContainer";

const Embed = () => {
  useScript(
    "https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.3.4/iframeResizer.contentWindow.min.js",
  );

  return (
    <>
      <FormContainer />
    </>
  );
};

export default Embed;
